module.exports = {
	"name": "rocket-forms",
	"version": "2.9.1",
	"description": "A collection of custom HTML form components for building interactive forms",
	"author": "Garrett <garrett@rocketmedia.com>",
	"private": true,
	"license": "UNLICENSED",
	"scripts": {
		"dev": "node build/dev-server.js",
		"prod": "node build/build.js && node build/prod-server.js",
		"start": "node build/dev-server.js",
		"build": "node build/build.js",
		"unit": "cross-env BABEL_ENV=test karma start test/unit/karma.conf.js",
		"e2e": "node test/e2e/runner.js",
		"test": "npm run unit && npm run e2e",
		"functional": "node test/functional.js",
		"lint": "eslint --ext .js,.vue src test/unit/specs test/e2e/specs"
	},
	"dependencies": {
		"axios": "^0.16.2",
		"bluebird": "^3.5.0",
		"element-dataset": "^2.2.6",
		"es6-promise": "^4.1.1",
		"https": "^1.0.0",
		"load-google-maps-api": "^1.0.0",
		"v-mask": "^1.3.0",
		"vee-validate": "^2.0.0-rc.8",
		"vue": "^2.4.2",
		"vue-awesome": "^2.3.1",
		"vue-scrollto": "^2.7.2"
	},
	"devDependencies": {
		"autoprefixer": "^6.7.2",
		"babel-core": "^6.25.0",
		"babel-eslint": "^7.1.1",
		"babel-loader": "^6.2.10",
		"babel-plugin-istanbul": "^4.1.1",
		"babel-plugin-transform-runtime": "^6.22.0",
		"babel-preset-env": "^1.6.0",
		"babel-preset-stage-2": "^6.22.0",
		"babel-register": "^6.22.0",
		"chai": "^3.5.0",
		"chalk": "^1.1.3",
		"chromedriver": "^2.31.0",
		"clipboard": "^1.7.1",
		"connect-history-api-fallback": "^1.3.0",
		"cross-env": "^4.0.0",
		"cross-spawn": "^5.0.1",
		"css-loader": "^0.28.0",
		"ejs-compiled-loader": "^1.1.0",
		"escape-html": "^1.0.3",
		"eslint": "^3.19.0",
		"eslint-config-standard": "^6.2.1",
		"eslint-friendly-formatter": "^2.0.7",
		"eslint-loader": "^1.9.0",
		"eslint-plugin-html": "^2.0.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-standard": "^2.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"express": "^4.14.1",
		"extract-text-webpack-plugin": "^2.1.2",
		"file-loader": "^0.11.1",
		"friendly-errors-webpack-plugin": "^1.1.3",
		"geckodriver": "^1.8.0",
		"highlight.js": "^9.12.0",
		"html-loader": "^0.4.5",
		"html-webpack-plugin": "^2.30.1",
		"http-proxy-middleware": "^0.17.3",
		"inject-loader": "^3.0.1",
		"install": "^0.10.1",
		"karma": "^1.4.1",
		"karma-coverage": "^1.1.1",
		"karma-mocha": "^1.3.0",
		"karma-phantomjs-launcher": "^1.0.2",
		"karma-phantomjs-shim": "^1.4.0",
		"karma-sinon-chai": "^1.3.1",
		"karma-sourcemap-loader": "^0.3.7",
		"karma-spec-reporter": "0.0.30",
		"karma-webpack": "^2.0.4",
		"lodash": "^4.17.4",
		"log-symbols": "^2.0.0",
		"lolex": "^1.5.2",
		"markdown-loader": "^2.0.1",
		"marked": "^0.3.6",
		"mocha": "^3.5.0",
		"nightwatch": "^0.9.16",
		"node-sass": "^4.5.3",
		"npm": "^5.3.0",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^1.3.0",
		"ora": "^1.3.0",
		"phantomjs-prebuilt": "^2.1.14",
		"rimraf": "^2.6.0",
		"sass-loader": "^6.0.6",
		"selenium-server": "^3.4.0",
		"semver": "^5.4.1",
		"shelljs": "^0.7.6",
		"sinon": "^2.4.1",
		"sinon-chai": "^2.12.0",
		"string-argv": "0.0.2",
		"style-loader": "^0.18.2",
		"url-loader": "^0.5.9",
		"vinyl-fs": "^2.4.4",
		"vue-loader": "^12.2.2",
		"vue-material": "^0.7.4",
		"vue-style-loader": "^3.0.1",
		"vue-template-compiler": "^2.4.2",
		"webpack": "^2.7.0",
		"webpack-auto-inject-version": "^0.5.14",
		"webpack-bundle-analyzer": "^2.8.3",
		"webpack-dev-middleware": "^1.12.0",
		"webpack-hot-middleware": "^2.18.2",
		"webpack-merge": "^4.1.0"
	},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"browserslist": [
		"> 1%",
		"last 2 versions",
		"not ie <= 8",
		"ie >= 10"
	]
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 269
// module chunks = 0